<template>
  <div class="case">
    <banner img="../assets/img/bgtop.jpg" />
    <div class="case-product">
      <div class="case-product-content">
        <img v-lazy="imgserver+caseIdList.img" alt />
        <p class="product-title">{{caseIdList.title}}</p>
        <p class="product-time">{{caseIdList.create_time}}</p>
        <p class="product-content" v-html="caseIdList.content"></p>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      pid: 0,
      caseIdList: {}
    };
  },
  created() {
    this.pid = this.$route.params.id;
    window.console.log(this.pid);
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$http
        .get(`/gw/Cases/get_cases_by_id/${this.pid}`)
        .then(response => {
          //console.log(response);
          this.caseIdList = response.data;
          window.console.log(this.caseIdList);
        })
        .catch(function(error) {
          window.console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #14679f;
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    //border: 1px solid red;
    &-content {
      width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 0;
      img {
        width: 100%;
        height: 430px;
      }
      .product-title {
        font-size: 25px;
        color: #e13834;
        padding: 20px 0;
      }
      .product-content {
        font-size: 17px;
        font-weight: bolder;
        padding: 20px 0;
      }
    }
  }
}
@media screen and (max-width: 700px) { /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
  .banner{
    height:100px;
  }
  .case-product{
    width: 100%;
  }
  .case-product-content{
    width: 100%;
  }
  .case-product-content img {
    width: 60%;
    height: 40%;
    margin: auto;
  }
  .case-product-content .product-title {
    font-size: 18px;
    color: #e13834;
    padding: 20px 20px;
    text-align: center;
  }
  .product-time{
    text-align: center;
    margin: auto;
  }
  .case-product-content .product-content {
    font-size: 17px;
    font-weight: bolder;
    padding: 20px 20px;
    text-indent:2em;
  }
}
</style>